import { t } from "@lingui/macro";
import React from "react";

import {
  Text,
  Box,
  HStack,
} from "@whoosh/design-system/src/components/primitive";
import { getTimeUntilDateString } from "@whoosh/utilities/src/dates";

export type EventStatusType =
  | "CONFIRMED"
  | "CLOSED"
  | "COMPLETE"
  | "DRAFT"
  | "FULL"
  | "PENDING"
  | "SIGNUP_AVAILABLE"
  | "WAITLIST_AVAILABLE"
  | "ON_WAITLIST";

type EventStatusProps = {
  eventStatus?: EventStatusType;
  opensAt?: string | null;
  spotsAvailable?: number | null;
};

export const EventStatus = ({
  eventStatus,
  spotsAvailable,
  opensAt,
}: EventStatusProps) => {
  const opensAtFormatted = opensAt ? getTimeUntilDateString(opensAt) : null;

  switch (eventStatus) {
    case "CLOSED":
      return (
        <Box bg="surface-primary" py={1} px={2} borderRadius="1">
          <Text
            maxFontSizeMultiplier={2}
            variant="mainTiny"
            color="text-secondary"
          >
            {t`Closed`}
          </Text>
        </Box>
      );
    case "COMPLETE":
      return (
        <Box bg="surface-primary" py={1} px={2} borderRadius="1">
          <Text
            maxFontSizeMultiplier={2}
            variant="mainTiny"
            color="text-secondary"
          >
            {t`Event Complete`}
          </Text>
        </Box>
      );
    case "FULL":
      return (
        <Box bg="surface-primary" py={1} px={2} borderRadius="1">
          <Text
            maxFontSizeMultiplier={2}
            variant="mainTiny"
            color="text-secondary"
          >
            {t`At Capacity`}
          </Text>
        </Box>
      );

    case "PENDING":
      return (
        <Box bg="surface-primary" py={1} px={2} borderRadius="1" width="100%">
          <Text
            maxFontSizeMultiplier={2}
            variant="mainTiny"
            color="text-primary"
          >
            {opensAtFormatted ? `${t`Opens`} ${opensAtFormatted}` : null}
          </Text>
        </Box>
      );

    case "SIGNUP_AVAILABLE":
      return (
        <HStack alignItems="center">
          <Box bg="surface-primary" py={1} px={2} borderRadius="1">
            <Text
              maxFontSizeMultiplier={2}
              variant="mainTiny"
              color="text-primary"
            >
              {t`Signup Available`}
            </Text>
          </Box>
        </HStack>
      );

    case "WAITLIST_AVAILABLE":
      return (
        <Box bg="surface-primary" py={1} px={2} borderRadius="1">
          <Text
            maxFontSizeMultiplier={2}
            variant="mainTiny"
            color="text-primary"
          >
            {t`Waitlist Available`}
          </Text>
        </Box>
      );

    case "CONFIRMED":
      return (
        <Box bg="surface-primary" py={1} px={2} borderRadius="1">
          <Text
            maxFontSizeMultiplier={2}
            variant="mainTiny"
            color="text-primary"
          >
            {t`Confirmed`}
          </Text>
        </Box>
      );

    case "ON_WAITLIST":
      return (
        <Box bg="surface-primary" py={1} px={2} borderRadius="1">
          <Text
            maxFontSizeMultiplier={2}
            variant="mainTiny"
            color="text-primary"
          >
            {t`On Waitlist`}
          </Text>
        </Box>
      );
    default:
      return null;
  }
};
